import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Clock, AlertCircle } from 'lucide-react';
export function WhyTailoring() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      title: 'Why tailoring matters (and why most people avoid it)',
      intro: 'Tailoring works because both ATS systems and recruiters prioritize relevance. But tailoring manually takes time:',
      painPoints: ['comparing your resume to each posting', 'rewriting bullets', 'adjusting skills and keywords', "writing a cover letter that doesn't feel generic", 'keeping everything ATS-friendly'],
      conclusion: 'So most candidates send the same resume everywhere and hope for the best.',
      solution: 'CV Go App makes tailoring repeatable—so you can apply smarter, not harder.'
    },
    es: {
      title: 'Por qué adaptar tu CV importa (y por qué casi nadie lo hace bien)',
      intro: 'Adaptar funciona porque tanto el ATS como el reclutador buscan relevancia para el puesto. Pero hacerlo manualmente consume tiempo:',
      painPoints: ['comparar tu CV con cada oferta', 'reescribir bullets', 'ajustar skills y keywords', 'escribir una cover letter que no suene genérica', 'mantener el documento ATS-friendly'],
      conclusion: 'Por eso muchos candidatos envían el mismo CV a todo y esperan resultados distintos.',
      solution: 'CV Go App convierte la adaptación en un proceso repetible—para que postules con estrategia, no por inercia.'
    }
  };
  const t = content[language];
  return <section className="py-20 bg-white" data-id="element-147">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="text-center mb-12" data-id="element-149">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-150">{t.title}</h2>
          <p className="text-lg text-gray-600" data-id="element-151">{t.intro}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-152">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-153">
            <div className="flex items-center gap-3 mb-6 text-red-700 font-semibold" data-id="element-154">
              <Clock className="w-6 h-6" data-id="element-155" />
              <span data-id="element-156">The Manual Way</span>
            </div>
            <ul className="space-y-3" data-id="element-157">
              {t.painPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-red-900/80" data-id="element-158">
                  <span className="text-red-400 mt-1" data-id="element-159">✕</span>
                  {point}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col justify-center space-y-6" data-id="element-160">
            <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-gray-300" data-id="element-161">
              <p className="text-gray-600 italic" data-id="element-162">"{t.conclusion}"</p>
            </div>

            <div className="bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500" data-id="element-163">
              <p className="text-blue-900 font-medium text-lg" data-id="element-164">{t.solution}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}